const accessLevelMap = {
	0: 'BasicUserLight',
	1: 'BasicUser',
	2: 'User',
	3: 'Admin',
	4: 'CustomerAdmin',
	5: 'CompanyAdmin',
	6: 'WebSbaAdmin'
};

const accessLevelKeyMap = {
  0: 'read_only',
  1: 'inspector',
  2: 'user',
  3: 'admin',
  4: 'customer_admin',
  5: 'company_admin',
  6: 'websba_admin'
};

export default {
  methods: {
    getAccessLevel(index) {
      return accessLevelMap[index] ?? null;
    },
    getAccessLevelName(index) {
      const key = accessLevelKeyMap[index];
      return key ? this.$t(`roles.${key}`) : '';
    }
  }
};